import styled from 'styled-components';

export const Svg = styled.svg`
  position: absolute;
  bottom: -20px;
  width: 100%;
  height: 20px;
`;

export const Path = styled.path`
  fill: ${props => props.theme.background};
`;
